<ngx-gallery *ngIf="items" [images]="items" [options]="galleryOptions"></ngx-gallery>
